import deviation from "../deviation";

export default function(values, min, max) {
  return Math.ceil((max - min) / (3.5 * deviation(values) * Math.pow(values.length, -1 / 3)));
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-array/src/threshold/scott.js
// module id = 1138
// module chunks = 0